import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { Store } from '@ngxs/store';
import { CartItem } from './state/cart.model';
import { CartState } from './state/cart.state';

@Component({
    selector: 'odq-cart',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false
})
export class CartComponent implements OnInit {
  displayedColumns: string[] = ['title', 'description', 'quantity', 'total'];
  items$: Observable<CartItem[]>;
  total$: Observable<number>;

  constructor(private store: Store,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.items$ = this.store.select<CartItem[]>(CartState.items);
    this.total$ = this.store.select<number>(CartState.total);
  }

  nextStep() {
    this.router.navigate(['checkout'], { relativeTo: this.route });
  }
}
